export default "__VITE_ASSET__BxdPhMIS__"